import { render, staticRenderFns } from "./PaymentNatures.vue?vue&type=template&id=6fc0ca4a"
import script from "./PaymentNatures.vue?vue&type=script&lang=js"
export * from "./PaymentNatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports